<p-table [value]="notes" *ngIf="!isLoading && notes && notes.length > 0">
    <ng-template pTemplate="header">
        <tr>
            <th class="colTitle title" (click)="sortBy('title')" [ngClass]="{'sort': this.frame.sortBy === 'title'}">Tytuł</th>
            <th class="colTitle price" (click)="sortBy('price')" [ngClass]="{'sort': this.frame.sortBy === 'price'}">Cena</th>
            <th class="colTitle date" (click)="sortBy('date')" [ngClass]="{'sort': this.frame.sortBy === 'date'}">Data dodania</th>
            <th class="colTitle active" (click)="sortBy('popular')" [ngClass]="{'sort': this.frame.sortBy === 'popular'}">Popularność</th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-note>
        <tr>
            <td ><a style="color: #40499b" routerLink="/my-account/note-edit/{{note.id}}">{{note.title}}</a></td>
            <td >{{note.price | currencyReduce | currency: selectedCurrency}}</td>
            <td >{{note.created_at}}</td>
            <td > <div style="width: 90px;height: 15px;border: 1px solid #ccc;"><div [style.width.%]="(note.offerts_count * 100) / 77" style="background-color: #40499b;height: 100%;"></div></div> </td>
        </tr>
    </ng-template>
</p-table>
<div *ngIf="!isLoading && notes.length == 0" style="display: flex;justify-content: center;">{{'arranger_empty_notes_list' | translate}}</div>
<app-loader *ngIf="isLoading"></app-loader>
